module.exports = __webpack_public_path__ + "static/media/UTA_Initials_white-orange-star-rgb.b7a18770.png";